/**
 * Created by JackCui on 2021/1/13
 */

import {CUSTOM} from './const'

/**
 * 绑定全部相关数据
 */

/**
 * 调用vm监听函数 做了节流处理
 * @param watchKey
 * @param eventHandle
 */
const watcher = function (watchKey, eventHandle) {
  let s

  this.$watch(watchKey, function () {
    // 防抖处理
    if (s) {
      clearTimeout(s)
    }
    s = setTimeout(() => {
      eventHandle && eventHandle(watchKey)
    }, 500)
  }, {
    deep: true
  })
}

/**
 * 批量监听formData中的全部字段
 * @param formKey
 * @param eventHandle
 */
export default function watchBind ({formKey, eventHandle}) {
  const values = this[formKey]

  for (let k in values) {
    if (!values.hasOwnProperty(k)) {
      continue
    }

    let watchKey = `${formKey}.${k}`

    // 处理预制对象中的自定义字段
    if (k === CUSTOM) {
      for (let v in values[k]) {
        if (!values[k].hasOwnProperty(v)) {
          continue
        }
        watcher.call(this, `${watchKey}.${v}`, eventHandle)
      }

      continue
    }

    watcher.call(this, watchKey, eventHandle)
  }
}
